import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import FindingYourOrangeCountyHome from "./sections/FindingYourOrangeCountyHome";
import OrangeCountyLife from "./sections/OrangeCountyLife";
import TheChrisStory from "./sections/TheChrisStory";
import YourPathHome from "./sections/YourPathHome";
import ReadyForAConsultation from "./sections/ReadyForAConsultation";
import SuccessStories from "./sections/SuccessStories";
import RealEstateHub from "./sections/RealEstateHub";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <FindingYourOrangeCountyHome />
      <OrangeCountyLife />
      <TheChrisStory />
      <YourPathHome />
      <ReadyForAConsultation />
      <SuccessStories />
      <RealEstateHub />
      <FooterInformation />
    </div>;
}